import get from 'lodash/get';
import analyticsConfig from '../../../../server/config/analytics';
import { figureOutPriorityTag } from '../../../../utils/ad_util';

export default function chartbeat(context = {}, location) {
  if (location === 'header') {
    return '<script type="text/javascript">var _sf_startpt=(new Date()).getTime();</script>';
  }

  const siteConfig = get(analyticsConfig, context.site);

  if (siteConfig === undefined) {
    return '';
  }

  const chartbeatConfig = get(siteConfig, 'chartbeat');
  const { uid, domain } = chartbeatConfig;
  const {
    postData,
    tagPageData,
    categoryPageData,
    authorPageData,
    type
  } = context;
  let authorName = '';
  let tags = [];
  let priorityTag = null;

  if (type === 'post') {
    tags = get(postData, 'tags');
    priorityTag = figureOutPriorityTag(tags);
    authorName = get(postData, 'author.slug') || '';
  }

  /*
    section: homepage=homepage,
    category page=name of topic(slugified),
    article=name of tag(slugified),
    tag page=name of tag(slugified)
  */
  let section = 'homepage';

  if (type === 'post' && priorityTag) {
    section = get(priorityTag, 'slug');
  } else if (type === 'category') {
    section = get(categoryPageData, 'slug');
  } else if (type === 'tag') {
    section = get(tagPageData, 'slug');
  } else if (type === 'author') {
    section = get(authorPageData, 'slug');
  } else if (type === 'search') {
    section = 'search';
  } else if (type === 'page') {
    section = 'page';
  }

  // @zhi todo, add sponsorName: "sponsor name goes here" to analytic tag
  return `
    <script type="text/javascript">
      var _sf_async_config = {
          useCanonical: true,
          uid: ${uid},
          domain: "${domain}",
          sections: "${section}",
          authors: "${authorName}"
      };

      (function () {
          function loadChartbeat() {
              window._sf_endpt = (new Date()).getTime();
              var e = document.createElement('script');
              e.setAttribute('language', 'javascript');
              e.setAttribute('type', 'text/javascript');
              e.setAttribute('src',
                      (("https:" == document.location.protocol) ? "https://a248.e.akamai.net/chartbeat.download.akamai.com/102508/" : "http://static.chartbeat.com/") +
                      "js/chartbeat_video.js");
              document.body.appendChild(e);
          }

          var oldonload = window.onload;
          window.onload = (typeof window.onload != 'function') ?
                  loadChartbeat : function () {
              oldonload();
              loadChartbeat();
          };
      })();
    </script>
  `;
}



// WEBPACK FOOTER //
// ./src/views/components/analytics/trackers/chartbeat.js